import { Box, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function TileCellGridOverlay({
  capturedTiles,
  gridCols,
  gridRows,
  totalTiles,
  currentTile,
  onSelectTile,
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "grid",
        gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
        gridTemplateRows: `repeat(${gridRows}, 1fr)`,
      }}
    >
      {Array.from({ length: totalTiles }).map((_, idx) => {
        const r = Math.floor(idx / gridCols);
        const c = idx % gridCols;
        const key = `${r}-${c}`;
        const tileMeta = capturedTiles[key];
        const done = !!tileMeta?.done;
        const uploading = tileMeta?.status === "uploading";
        const hasError = tileMeta?.status === "error";
        const active = idx === currentTile;

        return (
          <Box
            key={key}
            onClick={() => onSelectTile(idx)}
            sx={{
              cursor: "pointer",
              border: "1px solid rgba(255,255,255,0.35)",
              bgcolor: hasError
                ? "rgba(231,76,60,0.3)"
                : uploading
                  ? "rgba(52,152,219,0.28)"
                  : done
                    ? "rgba(46,204,113,0.24)"
                    : active
                      ? "rgba(0,229,255,0.18)"
                      : "rgba(0,0,0,0.12)",
              position: "relative",
              ...(active
                ? {
                    border: "2px solid #00e5ff",
                    animation: "tilePulse 1.2s infinite",
                  }
                : {}),
            }}
          >
            {done ? (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  right: 2,
                  bottom: 2,
                  fontSize: 14,
                  color: "#2ecc71",
                }}
              />
            ) : null}
            {uploading ? (
              <CircularProgress
                size={14}
                sx={{ position: "absolute", right: 2, bottom: 2, color: "#4fc3f7" }}
              />
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}

